<template>
  <div>
    <jade-alert
      showIcon
      variant="negative"
      :title="$t('title')"
    >
      {{ $t('description') }}
    </jade-alert>
  </div>
</template>

<script>
import { JadeAlert } from '@jade'
export default {
  name: 'ErrorAcquirerAffiliationAlert',

  components: {
    JadeAlert
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Tente novamente",
    "description": "Não foi possível cadastrar a afiliação."
  },
  "en-US": {
    "title": "Try again",
    "description": "Could not register the affiliation."
  }
}
</i18n>
